import { Button, Flex, Modal, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';

export default function AddToStorefrontCartModal({ isOpen, onClose, addToCart }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius="2xl">
                <Flex flexDir="column" mx="10" p="5" gap="5" my="7">
                    <Text fontSize="2xl" textAlign="center" fontWeight="bold">
                        Push to Cart
                    </Text>
                    <Text fontSize="lg" textAlign="center" my="3">
                        Are you sure you want to move this product to cart?
                    </Text>

                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        _hover={{ color: '#000', bg: 'white' }}
                        onClick={addToCart}>
                        Confirm
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        h="48px"
                        borderRadius="48px"
                        outline="none"
                        onClick={onClose}>
                        Cancel
                    </Button>
                </Flex>
            </ModalContent>
        </Modal>
    );
}
